/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReservationNotificationsV2200ResponseNotificationsInner } from './GetReservationNotificationsV2200ResponseNotificationsInner';
import {
    GetReservationNotificationsV2200ResponseNotificationsInnerFromJSON,
    GetReservationNotificationsV2200ResponseNotificationsInnerFromJSONTyped,
    GetReservationNotificationsV2200ResponseNotificationsInnerToJSON,
    GetReservationNotificationsV2200ResponseNotificationsInnerToJSONTyped,
} from './GetReservationNotificationsV2200ResponseNotificationsInner';

/**
 * 
 * @export
 * @interface GetReservationNotificationsV2200Response
 */
export interface GetReservationNotificationsV2200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationNotificationsV2200Response
     */
    whatsappEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationNotificationsV2200Response
     */
    hasWhatsappIntegration: boolean;
    /**
     * 
     * @type {Array<GetReservationNotificationsV2200ResponseNotificationsInner>}
     * @memberof GetReservationNotificationsV2200Response
     */
    notifications: Array<GetReservationNotificationsV2200ResponseNotificationsInner>;
}

/**
 * Check if a given object implements the GetReservationNotificationsV2200Response interface.
 */
export function instanceOfGetReservationNotificationsV2200Response(value: object): value is GetReservationNotificationsV2200Response {
    if (!('whatsappEnabled' in value) || value['whatsappEnabled'] === undefined) return false;
    if (!('hasWhatsappIntegration' in value) || value['hasWhatsappIntegration'] === undefined) return false;
    if (!('notifications' in value) || value['notifications'] === undefined) return false;
    return true;
}

export function GetReservationNotificationsV2200ResponseFromJSON(json: any): GetReservationNotificationsV2200Response {
    return GetReservationNotificationsV2200ResponseFromJSONTyped(json, false);
}

export function GetReservationNotificationsV2200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationNotificationsV2200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'whatsappEnabled': json['whatsappEnabled'],
        'hasWhatsappIntegration': json['hasWhatsappIntegration'],
        'notifications': ((json['notifications'] as Array<any>).map(GetReservationNotificationsV2200ResponseNotificationsInnerFromJSON)),
    };
}

export function GetReservationNotificationsV2200ResponseToJSON(json: any): GetReservationNotificationsV2200Response {
    return GetReservationNotificationsV2200ResponseToJSONTyped(json, false);
}

export function GetReservationNotificationsV2200ResponseToJSONTyped(value?: GetReservationNotificationsV2200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'whatsappEnabled': value['whatsappEnabled'],
        'hasWhatsappIntegration': value['hasWhatsappIntegration'],
        'notifications': ((value['notifications'] as Array<any>).map(GetReservationNotificationsV2200ResponseNotificationsInnerToJSON)),
    };
}

